import React, { Component } from 'react';
import logomotion from '../MyFiles/DinaPart-Motion.mp4';

class Welcome extends Component {
    render() { 
        //console.log("App - Welcome");
        return (
            <div className="App">
                <header className="App-header">
                    <video onEnded={() => this.props.handleVideoEnded()} autoPlay playsInline muted><source src={logomotion} type='video/mp4'></source></video>
                </header>
            </div>
        );
    }
}
 
export default Welcome;